﻿$.fn.dxCtrlPopupGridVue = function custom_dxCtrlPopupGridVue(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpopupgridvue dx-ctrl");
        this.createInstance(new cdxCtrlPopupGridVue(this, option));
    }
    return this;
}

var firstOpenPopGridVue = true
window.cdxCtrlPopupGridVue = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var popup = null
    function mConstruit() {
        container.empty();
        container.appendTo("body")
        popup = container.dxCtrlPopupBase({
            hideOnOutsideClick: false,
            fullScreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                contentElement.css("position", "relative")
                contentElement.css("padding", "5px")
                mConstruitPopElement(contentElement)
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    var dxGridStrCon = null
    function mConstruitPopElement(contentElement) {
        if (firstOpenPopGridVue) {
            firstOpenPopGridVue = false
            //on nettoie les vieux tempo
            $.each(option.bddCtrl.utiCourantParaJson, function (key, valeur) {
                // Vérifier si la clé commence par "datgh"
                if (key.startsWith("temp_gridvue_init_lstr_strcon_test_")) {
                    // Supprimer la propriété
                    delete option.bddCtrl.utiCourantParaJson[key];
                }
            });
        }

        var contextGrid = "temp_gridvue_init_lstr_strcon_test_" + (new Date()).getTime()
        dxGridStrCon = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlGridStrCon({
            bddCtrl: option.bddCtrl,
            noDataText: "Aucune fiche",
            context_grid: contextGrid,
            hideEntete: true,
            lstTypeGrille: ["Lignes"],
            dataGridFiltreBase: JSON.parse(option.dataGridVue.filter_json2),
            paddingLeftRightRow: "5px",
            showBtNew: false,
            allowCarto: false,
            allowCheck: false,
            allowClick: false,
            showFilterRempli:false
        }).dxCtrlGridStrCon("instance")

        mRempliFiltre(contentElement)

        window.setTimeout(function () {
            mNotify("Vous pouvez modifier les type de fiches affichés dans la vue (Structures, structures/contacts, contacts isolés) et le filtre qui est appliqué sur la vue.", "success", 10000)
        }, 2000)

    }

    function mRempliFiltre(contentElement) {
        var $DivFilter = $("<div style='height:100%;width:50%;max-width:700px;;position:absolute;top:0;right:0;box-shadow:0 0 50px 15px rgba(0, 0, 0, 1);' class='dx-theme-material-typography'/>").appendTo(contentElement)
        var $DivFilterInner = $("<div style='width:100%;height:100%;position:relative;padding:10px;border-left:" + theme.border + ";'/>").appendTo($DivFilter)

        $DivEntete = $("<div style='padding:0 10%;'/>").appendTo($DivFilterInner)
        if (option.dataGridVue.id_grid_vue < 100000) {
            $("<div style='margin:5px'/>").appendTo($DivEntete).dxCtrlWarningForm({
                type: "error",
                html: function () {
                    return "<span class='dxwarningformtext'>Cette vue est une vue système. Vous pouvez uniquement la consultez.<br/>Dupliquer cette vue pour créer votre propre vue à partir de celle-ci.</span>";
                },
            }).dxCtrlWarningForm("instance")
        }
        var $Table = $("<table style='width:100%'/>").appendTo($DivEntete)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        $("<div style='' class='barlow'/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Nom de la vue",
            value: option.dataGridVue.nom,
            maxLength: 100,
            disabled: (option.dataGridVue.id_grid_vue < 100000),
            onValueChanged: function (e) {
                option.dataGridVue.nom = e.value
                option.bddCtrl.getObjet(option.dataGridVue).mSaveChamp("nom")
            }
        })
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-arrow-right-from-bracket fa-rotate-180",
            hint: "Retirer la vue de la liste des vues affichée<br/>(La vue n'est pas supprimé, elle est simplement enlever de la liste de vos vues visibles)",
            onClick: function (e) {
                option.bddCtrl.mRemoveVueUti(option.dataGridVue.id_grid_vue)
                popup.hide()
                window.setTimeout(function () { option.onValueChanged() }, 0);
            }
        })
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)

        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%' colspan='1'/>").appendTo($Tr)
        $("<div style='' class='barlow'/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Description de la vue",
            value: option.dataGridVue.description,
            disabled: (option.dataGridVue.id_grid_vue < 100000),
            onValueChanged: function (e) {
                option.dataGridVue.description = e.value
                option.bddCtrl.getObjet(option.dataGridVue).mSaveChamp("description")
            }
        })
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-copy",
            hint: "Dupliquer la vue",
            onClick: function (e) {
                var newData = option.bddCtrl.getObjet("grid_vue").mGetNewData()
                for (var prop in option.dataGridVue) { newData[prop] = option.dataGridVue[prop] }
                var idx = 1
                while (option.bddCtrl.mGetArray("grid_vue").filter(function (o) { return o.nom == "(copie " + idx + ") " + newData.nom }).length > 0) {
                    idx += 1
                }
                newData.nom = "(copie " + idx + ") " + newData.nom
                newData.id_grid_vue = null
                option.bddCtrl.getObjet(newData).mSave(function (data) {
                    option.bddCtrl.mAddVueUti(newData.id_grid_vue)
                    $("<div/>").appendTo("body").dxCtrlPopupGridVue({
                        bddCtrl: option.bddCtrl,
                        dataGridVue: newData,
                        onValueChanged: option.onValueChanged()
                    })
                    popup.hide()
                    window.setTimeout(function () { option.onValueChanged() }, 0);
                })
            }
        })
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-trash-alt",
            hint: "Mettre la vue à la corbeille",
            onClick: function (e) {
                option.bddCtrl.getObjet(option.dataGridVue).mDelData(function (data) {
                    popup.hide()
                    window.setTimeout(function () { option.onValueChanged() }, 0);
                })
            }
        })

        dxBtClose = $("<div style='position:absolute;z-index:101;top:0px;right:0px'/>").appendTo($DivFilterInner).dxCtrlButton({
            icon: 'fas fa-times',
            width: HeightButton,
            height: HeightButton,
            onClick: function (e) {
                popup.hide()
                window.setTimeout(function () { option.onValueChanged() }, 0);
            }
        }).dxCtrlButton("instance");

        var dxFilter = $("<div style='height:calc(100% - " + ($DivEntete.innerHeight() + 10) + "px);width:100%;margin-top:20px;border-top:" + theme.border + ";'/>").appendTo($DivFilterInner).dxCtrlFilterStrConPage({
            bddCtrl: option.bddCtrl,
            dataFiltreGridStrCon: JSON.parse(option.dataGridVue.filter_json2),
            afficheClickListe: false,
            typeData:"strcon",
            onValueChanged: function (dataFiltreGridStrCon) {
                option.dataGridVue.filter_json2 = JSON.stringify(dataFiltreGridStrCon)
                option.bddCtrl.getObjet(option.dataGridVue).mSave()
                dxGridStrCon.mGetDxGrid().mUpdateDataFiltreGridBase(dataFiltreGridStrCon)
                //option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon = dataFiltreGridStrCon
                //option.bddCtrl.mSaveParaJsonUtilisateur();
                //Me.mReloadData(false)
            }
        }).dxCtrlFilterStrConPage("instance")

        resizeObserver.mAdd($DivEntete, function () { dxFilter.element().css("height", "calc(100% - " + ($DivEntete.innerHeight() + 10) + "px)"); })()
    }

    this.element = function () { return container }

    mConstruit();
}